import classNames from 'classnames';
import { useTranslation } from 'hooks';
import { FormLayout } from '../components/FormLayout';
import Input from 'components/ui/input';
import InputPassword from 'components/ui/inputPassword';
import { NewButton as Button } from '../components/NewButton';

interface Props {
  email: string;
  signUpLink: string;
  password: string;
  isLoading: boolean;
  validation: any;
  onChange: (key: string, value: string) => void;
  onLogin: () => void;
  goToResetPassword: () => void;
}

export const LoginForm: React.FC<Props> = ({
  email,
  password,
  isLoading,
  validation,
  signUpLink,
  onChange,
  goToResetPassword,
  onLogin,
}) => {
  const getTranslate = useTranslation();

  return (
    <>
      <FormLayout
        title='auth.login.header'
        body={
          <>
            <Input
              disabled={isLoading}
              id='email'
              label={getTranslate('auth.email.label')}
              placeholder={getTranslate('auth.email.placeholder')}
              value={email}
              onChange={(event) => onChange('email', event.target.value)}
              modern
            />

            <InputPassword
              disabled={isLoading}
              id='password'
              value={password}
              label={getTranslate('auth.password.label')}
              placeholder={getTranslate('auth.password.placeholder')}
              customClass={classNames({ 'ui-input_empty': !password })}
              onChange={(event) => onChange('password', event.target.value)}
              modern
            />

            {validation ? (
              <div className='form-layout__error-wrapper'>
                {validation.email ? (
                  <p className='form-layout__error'>
                    {getTranslate(validation.email)}
                  </p>
                ) : null}
                {validation.password ? (
                  <p className='form-layout__error'>
                    {getTranslate(validation.password)}
                  </p>
                ) : null}
              </div>
            ) : null}
          </>
        }
        submitButton={
          <Button isLoading={isLoading} type='submit'>
            {getTranslate('auth.login.button')}
          </Button>
        }
        onSubmit={onLogin}
      />

      {signUpLink ? (
        <div className='form-layout__link'>
          <a
            href={signUpLink}
            target='_blank'
            rel='noreferrer noopener'
            className='utils-link'>
            {getTranslate('auth.signUp.link')}
          </a>
        </div>
      ) : null}
      <div className='form-layout__link'>
        <span onClick={goToResetPassword} className='utils-link'>
          {getTranslate('auth.forgotPassword.link')}
        </span>
      </div>
    </>
  );
};
